var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5882 16.4708C8.36516 16.4708 8.18992 16.3887 8.06246 16.2246L3.09188 11.1053C2.93256 10.974 2.85291 10.7935 2.85291 10.5638C2.85291 10.3341 2.93256 10.1536 3.09188 10.0223L4.14335 8.89015C4.30266 8.72607 4.48587 8.64403 4.69298 8.64403C4.90009 8.64403 5.0833 8.72607 5.24261 8.89015L8.5882 12.3359L15.7573 4.95218C15.9166 4.7881 16.0998 4.70605 16.3069 4.70605C16.5141 4.70605 16.6973 4.7881 16.8566 4.95218L17.9081 6.08435C18.0674 6.21561 18.147 6.3961 18.147 6.62582C18.147 6.85553 18.0674 7.03602 17.9081 7.16729L9.11393 16.2246C8.98648 16.3887 8.81124 16.4708 8.5882 16.4708Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckLg);
export default __webpack_public_path__ + "static/media/icon-check-lg.805575f0ae0d22101087231f843163c8.svg";
export { ForwardRef as ReactComponent };